import { render, staticRenderFns } from "./customerSearchInput.vue?vue&type=template&id=1ff36f7e"
import script from "./customerSearchInput.vue?vue&type=script&lang=js"
export * from "./customerSearchInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports